import o from "./Add.js";
import e from "./Alert.js";
import t from "./ApplePay.js";
import m from "./ArrowRight.js";
import n from "./Card.js";
import i from "./Change.js";
import a from "./ChevronDown.js";
import c from "./ChevronLeft.js";
import p from "./ChevronRight.js";
import s from "./ChevronUp.js";
import u from "./CircleArrowRight.js";
import f from "./CircleTick.js";
import l from "./Clock.js";
import h from "./Close.js";
import C from "./Delete.js";
import d from "./Download.js";
import g from "./DropdownArrow.js";
import w from "./ExternalLink.js";
import A from "./FaceScan.js";
import P from "./GooglePay.js";
import v from "./Home.js";
import k from "./Info.js";
import D from "./License.js";
import F from "./Mastercard.js";
import I from "./Minus.js";
import S from "./Passport.js";
import T from "./Paypal.js";
import L from "./Phone.js";
import y from "./Plus.js";
import U from "./Slash.js";
import R from "./Smile.js";
import V from "./Spinner.js";
import { ThumbDownIcon as H } from "./ThumbDown.js";
import { ThumbUpIcon as $ } from "./ThumbUp.js";
import b from "./Tick.js";
import x from "./Upload.js";
import M from "./User.js";
import G from "./VicServiceLogo.js";
import E from "./Viclogo.js";
import j from "./Visa.js";
const Lr = (r) => {
  if (r)
    switch (r) {
      case "Add":
        return o;
      case "Alert":
        return e;
      case "ApplePay":
        return t;
      case "ArrowRight":
        return m;
      case "Change":
        return i;
      case "Card":
        return n;
      case "ChevronLeft":
        return c;
      case "ChevronRight":
        return p;
      case "ChevronDown":
        return a;
      case "ChevronUp":
        return s;
      case "CircleTick":
        return f;
      case "CircleArrowRight":
        return u;
      case "Clock":
        return l;
      case "Close":
        return h;
      case "Delete":
        return C;
      case "Download":
        return d;
      case "DropdownArrow":
        return g;
      case "ExternalLink":
        return w;
      case "FaceScan":
        return A;
      case "Upload":
        return x;
      case "GooglePay":
        return P;
      case "Home":
        return v;
      case "Info":
        return k;
      case "License":
        return D;
      case "Minus":
        return I;
      case "Passport":
        return S;
      case "Phone":
        return L;
      case "Paypal":
        return T;
      case "Plus":
        return y;
      case "Slash":
        return U;
      case "Smile":
        return R;
      case "Spinner":
        return V;
      case "Tick":
        return b;
      case "User":
        return M;
      case "Viclogo":
        return E;
      case "VicServiceLogo":
        return G;
      default:
        return;
    }
}, yr = {
  Add: o,
  Alert: e,
  ApplePay: t,
  ArrowRight: m,
  Card: n,
  Change: i,
  ChevronLeft: c,
  ChevronRight: p,
  ChevronDown: a,
  ChevronUp: s,
  CircleTick: f,
  CircleArrowRight: u,
  Close: h,
  Clock: l,
  Delete: C,
  Download: d,
  DropdownArrow: g,
  ExternalLink: w,
  FaceScan: A,
  GooglePay: P,
  Home: v,
  Info: k,
  License: D,
  Mastercard: F,
  Minus: I,
  Passport: S,
  Upload: x,
  Phone: L,
  Paypal: T,
  Plus: y,
  Slash: U,
  Smile: R,
  Spinner: V,
  Tick: b,
  ThumbDown: H,
  ThumbUp: $,
  User: M,
  Viclogo: E,
  VicServiceLogo: G,
  Visa: j
};
export {
  yr as default,
  Lr as loadIcon
};
